import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import * as actions from "../../../store/actions";
import { useInfiniteScroll } from "../../../utils/pagination";

import NoteTemplateList from "./NoteTemplateList";
import SearchBox from "../../../components/formElements/searchbox/SearchBox";
import Button from "../../../components/formElements/button/Button";

import "./index.css";

const NoteTemplates = ({
  history,
  templates,
  getAllTemplates,
  setEditMode,
  total_pages,
  emptyTemplateData,
  searchTemplates,
  searchData,
  searchValue,
}) => {
  const [page, setPage] = useState(0);

  const mloader = useRef(null);

  useEffect(() => {
    if (page > 0 && page <= total_pages && !searchValue) {
      getAllTemplates("", page);
    } else if (
      searchValue &&
      searchValue.length >= 3 &&
      page > 0 &&
      page <= total_pages
    ) {
      getAllTemplates(searchValue, page);
    }
    // eslint-disable-next-line
  }, [page, searchValue]);

  useInfiniteScroll(mloader, () => {
    setPage(page => page + 1);
  });

  useEffect(() => {
    emptyTemplateData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div>
        <p className="DBSubTitle b-2">Note Templates</p>
      </div>

      <div className="row col-md-12 notes w-100">
        <div className="col-md-5 mt-2 p-0">
          <SearchBox
            value={searchValue || ""}
            onChange={val => {
              searchTemplates({
                searchValue: val,
                total_pages: 1,
              });
              setPage(1);
            }}
          />
        </div>

        <div className="col-md-3 ml-auto ">
          <Button
            label="Create Note"
            className="btn-block"
            onClick={() => {
              history.push(`${history.location.pathname}/create`);
            }}
            style={{ fontWeight: "normal" }}
          />
        </div>
      </div>
      <NoteTemplateList
        templates={templates}
        setEditMode={setEditMode}
        searchedResult={searchData}
        searchValue={searchValue}
      />

      <div ref={mloader}></div>
    </>
  );
};

const mapStoreToProps = ({ dashboard, validation }) => ({
  templates: dashboard.templates.all,
  searchData: dashboard.templates.search,
  searchValue: dashboard.templates.searchValue,
  form: validation.data,
  total_pages: dashboard.templates.total_pages,
});

const mapDispatchToProps = dispatch => ({
  getAllTemplates: (q, page) => dispatch(actions.getAllTemlates(q, page)),
  setEditMode: () => dispatch(actions.setEditMode()),
  emptyTemplateData: () => dispatch(actions.emptyTemplateData()),
  searchTemplates: q => dispatch(actions.templateSearch(q)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(NoteTemplates)
);
